import React from 'react';
import { Box, Text, IconButton } from '@chakra-ui/react';
import { useLocation, Link } from 'react-router-dom';

const NavItem = ({ icon, to, tooltip }) => {
  const location = useLocation();
  const isActive = location.pathname === to;
  
  return (
    <Box 
      width="full" 
      display="flex" 
      alignItems="center" 
      justifyContent="center"
      className="nav-item"
      position="relative"
    >
      <Link to={to} style={{ width: '100%', textAlign: 'center' }}>
        <IconButton
          aria-label={tooltip}
          icon={icon}
          bg={isActive ? 'rgba(16, 185, 129, 0.1)' : 'transparent'}
          color={isActive ? 'crypto.green.500' : 'gray.400'}
          borderRadius="lg"
          _hover={{ bg: isActive ? 'rgba(16, 185, 129, 0.15)' : 'whiteAlpha.100' }}
          size="md"
          variant="ghost"
          my={1}
        />
      </Link>
      
      {/* Tooltip */}
     <Box className="nav-tooltip">
  <Box 
    bg="rgba(15, 27, 14, 0.9)"  // Darker shade matching your theme
    color="crypto.green.200"     // Green text to match your theme
    fontSize="xs" 
   
    py={1} 
    px={1.5} 
    borderWidth="1px"
    borderColor="rgba(78, 224, 53, 0.2)"  // Matching your border style

  >
    <Text whiteSpace="nowrap" fontWeight="medium">
      {tooltip}
    </Text>
  </Box>
</Box>
    </Box>
  );
};

export default NavItem;